import Pe, { useEffect as fr, useState as dr } from "react";
import { Dropdown as V, Button as vr } from "react-bootstrap";
import { useTranslation as pr } from "react-i18next";
import Te from "mermaid";
var Z = { exports: {} }, I = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Oe;
function hr() {
  if (Oe)
    return I;
  Oe = 1;
  var m = Pe, R = Symbol.for("react.element"), u = Symbol.for("react.fragment"), v = Object.prototype.hasOwnProperty, y = m.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, S = { key: !0, ref: !0, __self: !0, __source: !0 };
  function E(g, f, _) {
    var d, C = {}, w = null, L = null;
    _ !== void 0 && (w = "" + _), f.key !== void 0 && (w = "" + f.key), f.ref !== void 0 && (L = f.ref);
    for (d in f)
      v.call(f, d) && !S.hasOwnProperty(d) && (C[d] = f[d]);
    if (g && g.defaultProps)
      for (d in f = g.defaultProps, f)
        C[d] === void 0 && (C[d] = f[d]);
    return { $$typeof: R, type: g, key: w, ref: L, props: C, _owner: y.current };
  }
  return I.Fragment = u, I.jsx = E, I.jsxs = E, I;
}
var M = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Se;
function mr() {
  return Se || (Se = 1, process.env.NODE_ENV !== "production" && function() {
    var m = Pe, R = Symbol.for("react.element"), u = Symbol.for("react.portal"), v = Symbol.for("react.fragment"), y = Symbol.for("react.strict_mode"), S = Symbol.for("react.profiler"), E = Symbol.for("react.provider"), g = Symbol.for("react.context"), f = Symbol.for("react.forward_ref"), _ = Symbol.for("react.suspense"), d = Symbol.for("react.suspense_list"), C = Symbol.for("react.memo"), w = Symbol.for("react.lazy"), L = Symbol.for("react.offscreen"), Q = Symbol.iterator, xe = "@@iterator";
    function ke(e) {
      if (e === null || typeof e != "object")
        return null;
      var r = Q && e[Q] || e[xe];
      return typeof r == "function" ? r : null;
    }
    var D = m.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function p(e) {
      {
        for (var r = arguments.length, t = new Array(r > 1 ? r - 1 : 0), a = 1; a < r; a++)
          t[a - 1] = arguments[a];
        je("error", e, t);
      }
    }
    function je(e, r, t) {
      {
        var a = D.ReactDebugCurrentFrame, o = a.getStackAddendum();
        o !== "" && (r += "%s", t = t.concat([o]));
        var s = t.map(function(i) {
          return String(i);
        });
        s.unshift("Warning: " + r), Function.prototype.apply.call(console[e], console, s);
      }
    }
    var Ae = !1, Fe = !1, Ie = !1, Me = !1, Le = !1, ee;
    ee = Symbol.for("react.module.reference");
    function Ye(e) {
      return !!(typeof e == "string" || typeof e == "function" || e === v || e === S || Le || e === y || e === _ || e === d || Me || e === L || Ae || Fe || Ie || typeof e == "object" && e !== null && (e.$$typeof === w || e.$$typeof === C || e.$$typeof === E || e.$$typeof === g || e.$$typeof === f || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      e.$$typeof === ee || e.getModuleId !== void 0));
    }
    function $e(e, r, t) {
      var a = e.displayName;
      if (a)
        return a;
      var o = r.displayName || r.name || "";
      return o !== "" ? t + "(" + o + ")" : t;
    }
    function re(e) {
      return e.displayName || "Context";
    }
    function T(e) {
      if (e == null)
        return null;
      if (typeof e.tag == "number" && p("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof e == "function")
        return e.displayName || e.name || null;
      if (typeof e == "string")
        return e;
      switch (e) {
        case v:
          return "Fragment";
        case u:
          return "Portal";
        case S:
          return "Profiler";
        case y:
          return "StrictMode";
        case _:
          return "Suspense";
        case d:
          return "SuspenseList";
      }
      if (typeof e == "object")
        switch (e.$$typeof) {
          case g:
            var r = e;
            return re(r) + ".Consumer";
          case E:
            var t = e;
            return re(t._context) + ".Provider";
          case f:
            return $e(e, e.render, "ForwardRef");
          case C:
            var a = e.displayName || null;
            return a !== null ? a : T(e.type) || "Memo";
          case w: {
            var o = e, s = o._payload, i = o._init;
            try {
              return T(i(s));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var P = Object.assign, A = 0, te, ae, ne, ie, oe, se, le;
    function ue() {
    }
    ue.__reactDisabledLog = !0;
    function Ne() {
      {
        if (A === 0) {
          te = console.log, ae = console.info, ne = console.warn, ie = console.error, oe = console.group, se = console.groupCollapsed, le = console.groupEnd;
          var e = {
            configurable: !0,
            enumerable: !0,
            value: ue,
            writable: !0
          };
          Object.defineProperties(console, {
            info: e,
            log: e,
            warn: e,
            error: e,
            group: e,
            groupCollapsed: e,
            groupEnd: e
          });
        }
        A++;
      }
    }
    function Ue() {
      {
        if (A--, A === 0) {
          var e = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: P({}, e, {
              value: te
            }),
            info: P({}, e, {
              value: ae
            }),
            warn: P({}, e, {
              value: ne
            }),
            error: P({}, e, {
              value: ie
            }),
            group: P({}, e, {
              value: oe
            }),
            groupCollapsed: P({}, e, {
              value: se
            }),
            groupEnd: P({}, e, {
              value: le
            })
          });
        }
        A < 0 && p("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var q = D.ReactCurrentDispatcher, J;
    function Y(e, r, t) {
      {
        if (J === void 0)
          try {
            throw Error();
          } catch (o) {
            var a = o.stack.trim().match(/\n( *(at )?)/);
            J = a && a[1] || "";
          }
        return `
` + J + e;
      }
    }
    var B = !1, $;
    {
      var We = typeof WeakMap == "function" ? WeakMap : Map;
      $ = new We();
    }
    function ce(e, r) {
      if (!e || B)
        return "";
      {
        var t = $.get(e);
        if (t !== void 0)
          return t;
      }
      var a;
      B = !0;
      var o = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var s;
      s = q.current, q.current = null, Ne();
      try {
        if (r) {
          var i = function() {
            throw Error();
          };
          if (Object.defineProperty(i.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(i, []);
            } catch (O) {
              a = O;
            }
            Reflect.construct(e, [], i);
          } else {
            try {
              i.call();
            } catch (O) {
              a = O;
            }
            e.call(i.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (O) {
            a = O;
          }
          e();
        }
      } catch (O) {
        if (O && a && typeof O.stack == "string") {
          for (var n = O.stack.split(`
`), h = a.stack.split(`
`), l = n.length - 1, c = h.length - 1; l >= 1 && c >= 0 && n[l] !== h[c]; )
            c--;
          for (; l >= 1 && c >= 0; l--, c--)
            if (n[l] !== h[c]) {
              if (l !== 1 || c !== 1)
                do
                  if (l--, c--, c < 0 || n[l] !== h[c]) {
                    var b = `
` + n[l].replace(" at new ", " at ");
                    return e.displayName && b.includes("<anonymous>") && (b = b.replace("<anonymous>", e.displayName)), typeof e == "function" && $.set(e, b), b;
                  }
                while (l >= 1 && c >= 0);
              break;
            }
        }
      } finally {
        B = !1, q.current = s, Ue(), Error.prepareStackTrace = o;
      }
      var k = e ? e.displayName || e.name : "", Ce = k ? Y(k) : "";
      return typeof e == "function" && $.set(e, Ce), Ce;
    }
    function Ve(e, r, t) {
      return ce(e, !1);
    }
    function qe(e) {
      var r = e.prototype;
      return !!(r && r.isReactComponent);
    }
    function N(e, r, t) {
      if (e == null)
        return "";
      if (typeof e == "function")
        return ce(e, qe(e));
      if (typeof e == "string")
        return Y(e);
      switch (e) {
        case _:
          return Y("Suspense");
        case d:
          return Y("SuspenseList");
      }
      if (typeof e == "object")
        switch (e.$$typeof) {
          case f:
            return Ve(e.render);
          case C:
            return N(e.type, r, t);
          case w: {
            var a = e, o = a._payload, s = a._init;
            try {
              return N(s(o), r, t);
            } catch {
            }
          }
        }
      return "";
    }
    var U = Object.prototype.hasOwnProperty, fe = {}, de = D.ReactDebugCurrentFrame;
    function W(e) {
      if (e) {
        var r = e._owner, t = N(e.type, e._source, r ? r.type : null);
        de.setExtraStackFrame(t);
      } else
        de.setExtraStackFrame(null);
    }
    function Je(e, r, t, a, o) {
      {
        var s = Function.call.bind(U);
        for (var i in e)
          if (s(e, i)) {
            var n = void 0;
            try {
              if (typeof e[i] != "function") {
                var h = Error((a || "React class") + ": " + t + " type `" + i + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof e[i] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw h.name = "Invariant Violation", h;
              }
              n = e[i](r, i, a, t, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (l) {
              n = l;
            }
            n && !(n instanceof Error) && (W(o), p("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", a || "React class", t, i, typeof n), W(null)), n instanceof Error && !(n.message in fe) && (fe[n.message] = !0, W(o), p("Failed %s type: %s", t, n.message), W(null));
          }
      }
    }
    var Be = Array.isArray;
    function G(e) {
      return Be(e);
    }
    function Ge(e) {
      {
        var r = typeof Symbol == "function" && Symbol.toStringTag, t = r && e[Symbol.toStringTag] || e.constructor.name || "Object";
        return t;
      }
    }
    function ze(e) {
      try {
        return ve(e), !1;
      } catch {
        return !0;
      }
    }
    function ve(e) {
      return "" + e;
    }
    function pe(e) {
      if (ze(e))
        return p("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Ge(e)), ve(e);
    }
    var F = D.ReactCurrentOwner, He = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, he, me, z;
    z = {};
    function Ke(e) {
      if (U.call(e, "ref")) {
        var r = Object.getOwnPropertyDescriptor(e, "ref").get;
        if (r && r.isReactWarning)
          return !1;
      }
      return e.ref !== void 0;
    }
    function Xe(e) {
      if (U.call(e, "key")) {
        var r = Object.getOwnPropertyDescriptor(e, "key").get;
        if (r && r.isReactWarning)
          return !1;
      }
      return e.key !== void 0;
    }
    function Ze(e, r) {
      if (typeof e.ref == "string" && F.current && r && F.current.stateNode !== r) {
        var t = T(F.current.type);
        z[t] || (p('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', T(F.current.type), e.ref), z[t] = !0);
      }
    }
    function Qe(e, r) {
      {
        var t = function() {
          he || (he = !0, p("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", r));
        };
        t.isReactWarning = !0, Object.defineProperty(e, "key", {
          get: t,
          configurable: !0
        });
      }
    }
    function er(e, r) {
      {
        var t = function() {
          me || (me = !0, p("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", r));
        };
        t.isReactWarning = !0, Object.defineProperty(e, "ref", {
          get: t,
          configurable: !0
        });
      }
    }
    var rr = function(e, r, t, a, o, s, i) {
      var n = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: R,
        // Built-in properties that belong on the element
        type: e,
        key: r,
        ref: t,
        props: i,
        // Record the component responsible for creating this element.
        _owner: s
      };
      return n._store = {}, Object.defineProperty(n._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(n, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: a
      }), Object.defineProperty(n, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: o
      }), Object.freeze && (Object.freeze(n.props), Object.freeze(n)), n;
    };
    function tr(e, r, t, a, o) {
      {
        var s, i = {}, n = null, h = null;
        t !== void 0 && (pe(t), n = "" + t), Xe(r) && (pe(r.key), n = "" + r.key), Ke(r) && (h = r.ref, Ze(r, o));
        for (s in r)
          U.call(r, s) && !He.hasOwnProperty(s) && (i[s] = r[s]);
        if (e && e.defaultProps) {
          var l = e.defaultProps;
          for (s in l)
            i[s] === void 0 && (i[s] = l[s]);
        }
        if (n || h) {
          var c = typeof e == "function" ? e.displayName || e.name || "Unknown" : e;
          n && Qe(i, c), h && er(i, c);
        }
        return rr(e, n, h, o, a, F.current, i);
      }
    }
    var H = D.ReactCurrentOwner, ge = D.ReactDebugCurrentFrame;
    function x(e) {
      if (e) {
        var r = e._owner, t = N(e.type, e._source, r ? r.type : null);
        ge.setExtraStackFrame(t);
      } else
        ge.setExtraStackFrame(null);
    }
    var K;
    K = !1;
    function X(e) {
      return typeof e == "object" && e !== null && e.$$typeof === R;
    }
    function _e() {
      {
        if (H.current) {
          var e = T(H.current.type);
          if (e)
            return `

Check the render method of \`` + e + "`.";
        }
        return "";
      }
    }
    function ar(e) {
      {
        if (e !== void 0) {
          var r = e.fileName.replace(/^.*[\\\/]/, ""), t = e.lineNumber;
          return `

Check your code at ` + r + ":" + t + ".";
        }
        return "";
      }
    }
    var be = {};
    function nr(e) {
      {
        var r = _e();
        if (!r) {
          var t = typeof e == "string" ? e : e.displayName || e.name;
          t && (r = `

Check the top-level render call using <` + t + ">.");
        }
        return r;
      }
    }
    function Ee(e, r) {
      {
        if (!e._store || e._store.validated || e.key != null)
          return;
        e._store.validated = !0;
        var t = nr(r);
        if (be[t])
          return;
        be[t] = !0;
        var a = "";
        e && e._owner && e._owner !== H.current && (a = " It was passed a child from " + T(e._owner.type) + "."), x(e), p('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', t, a), x(null);
      }
    }
    function Re(e, r) {
      {
        if (typeof e != "object")
          return;
        if (G(e))
          for (var t = 0; t < e.length; t++) {
            var a = e[t];
            X(a) && Ee(a, r);
          }
        else if (X(e))
          e._store && (e._store.validated = !0);
        else if (e) {
          var o = ke(e);
          if (typeof o == "function" && o !== e.entries)
            for (var s = o.call(e), i; !(i = s.next()).done; )
              X(i.value) && Ee(i.value, r);
        }
      }
    }
    function ir(e) {
      {
        var r = e.type;
        if (r == null || typeof r == "string")
          return;
        var t;
        if (typeof r == "function")
          t = r.propTypes;
        else if (typeof r == "object" && (r.$$typeof === f || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        r.$$typeof === C))
          t = r.propTypes;
        else
          return;
        if (t) {
          var a = T(r);
          Je(t, e.props, "prop", a, e);
        } else if (r.PropTypes !== void 0 && !K) {
          K = !0;
          var o = T(r);
          p("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", o || "Unknown");
        }
        typeof r.getDefaultProps == "function" && !r.getDefaultProps.isReactClassApproved && p("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function or(e) {
      {
        for (var r = Object.keys(e.props), t = 0; t < r.length; t++) {
          var a = r[t];
          if (a !== "children" && a !== "key") {
            x(e), p("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", a), x(null);
            break;
          }
        }
        e.ref !== null && (x(e), p("Invalid attribute `ref` supplied to `React.Fragment`."), x(null));
      }
    }
    function ye(e, r, t, a, o, s) {
      {
        var i = Ye(e);
        if (!i) {
          var n = "";
          (e === void 0 || typeof e == "object" && e !== null && Object.keys(e).length === 0) && (n += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var h = ar(o);
          h ? n += h : n += _e();
          var l;
          e === null ? l = "null" : G(e) ? l = "array" : e !== void 0 && e.$$typeof === R ? (l = "<" + (T(e.type) || "Unknown") + " />", n = " Did you accidentally export a JSX literal instead of a component?") : l = typeof e, p("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", l, n);
        }
        var c = tr(e, r, t, o, s);
        if (c == null)
          return c;
        if (i) {
          var b = r.children;
          if (b !== void 0)
            if (a)
              if (G(b)) {
                for (var k = 0; k < b.length; k++)
                  Re(b[k], e);
                Object.freeze && Object.freeze(b);
              } else
                p("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Re(b, e);
        }
        return e === v ? or(c) : ir(c), c;
      }
    }
    function sr(e, r, t) {
      return ye(e, r, t, !0);
    }
    function lr(e, r, t) {
      return ye(e, r, t, !1);
    }
    var ur = lr, cr = sr;
    M.Fragment = v, M.jsx = ur, M.jsxs = cr;
  }()), M;
}
process.env.NODE_ENV === "production" ? Z.exports = hr() : Z.exports = mr();
var j = Z.exports;
const De = (m) => {
  const R = (u) => {
    Te.initialize({ startOnLoad: !1 }), u.querySelectorAll(".language-mermaid").forEach((v) => {
      const y = Date.now();
      Te.render(
        `theGraph${y}`,
        v.textContent || "",
        function(S) {
          var g;
          const E = document.createElement("p");
          E.className = "text-center", E.innerHTML = S, (g = v.parentNode) == null || g.replaceChild(E, v);
        }
      );
    });
  };
  fr(() => {
    if (!m)
      return;
    let u;
    m instanceof HTMLElement ? u = m : u = m.current, R(u);
    const v = new MutationObserver(() => {
      R(u);
    });
    return v.observe(u, {
      childList: !0,
      attributes: !0,
      subtree: !0
    }), () => {
      v.disconnect();
    };
  }, [m]);
}, gr = ({ editor: m, previewElement: R }) => {
  De(R);
  const { t: u } = pr("plugin", {
    keyPrefix: "chart_editor.frontend"
  }), [v, y] = dr(!1), S = () => {
    v || y(!0);
  }, E = () => {
    y(!1);
  }, g = [
    {
      label: u("flow_chart"),
      tpl: `graph TD
      A[Christmas] -->|Get money| B(Go shopping)
      B --> C{Let me think}
      C -->|One| D[Laptop]
      C -->|Two| E[iPhone]
      C -->|Three| F[fa:fa-car Car]`
    },
    {
      label: u("sequence_diagram"),
      tpl: `sequenceDiagram
      Alice->>+John: Hello John, how are you?
      Alice->>+John: John, can you hear me?
      John-->>-Alice: Hi Alice, I can hear you!
      John-->>-Alice: I feel great!
              `
    },
    {
      label: u("state_diagram"),
      tpl: `stateDiagram-v2
      [*] --> Still
      Still --> [*]
      Still --> Moving
      Moving --> Still
      Moving --> Crash
      Crash --> [*]
              `
    },
    {
      label: u("class_diagram"),
      tpl: `classDiagram
      Animal <|-- Duck
      Animal <|-- Fish
      Animal <|-- Zebra
      Animal : +int age
      Animal : +String gender
      Animal: +isMammal()
      Animal: +mate()
      class Duck{
        +String beakColor
        +swim()
        +quack()
      }
      class Fish{
        -int sizeInFeet
        -canEat()
      }
      class Zebra{
        +bool is_wild
        +run()
      }
              `
    },
    {
      label: u("pie_chart"),
      tpl: `pie title Pets adopted by volunteers
      "Dogs" : 386
      "Cats" : 85
      "Rats" : 15
              `
    },
    {
      label: u("gantt_chart"),
      tpl: `gantt
      title A Gantt Diagram
      dateFormat  YYYY-MM-DD
      section Section
      A task           :a1, 2014-01-01, 30d
      Another task     :after a1  , 20d
      section Another
      Task in sec      :2014-01-12  , 12d
      another task      : 24d
              `
    },
    {
      label: u("entity_relationship_diagram"),
      tpl: `erDiagram
      CUSTOMER }|..|{ DELIVERY-ADDRESS : has
      CUSTOMER ||--o{ ORDER : places
      CUSTOMER ||--o{ INVOICE : "liable for"
      DELIVERY-ADDRESS ||--o{ ORDER : receives
      INVOICE ||--|{ ORDER : covers
      ORDER ||--|{ ORDER-ITEM : includes
      PRODUCT-CATEGORY ||--|{ PRODUCT : contains
      PRODUCT ||--o{ ORDER-ITEM : "ordered in"
        `
    }
  ], f = (_) => {
    const { ch: d } = m.getCursor();
    m.replaceSelection(`${d ? `
` : ""}\`\`\`mermaid
${_}
\`\`\`
`);
  };
  return /* @__PURE__ */ j.jsx("div", { className: "toolbar-item-wrap", children: /* @__PURE__ */ j.jsxs(V, { children: [
    /* @__PURE__ */ j.jsx(
      V.Toggle,
      {
        type: "button",
        as: vr,
        variant: "link",
        title: u("title"),
        className: "p-0 b-0 btn-no-border toolbar text-body",
        children: /* @__PURE__ */ j.jsx("i", { className: "bi bi-diagram-3-fill" })
      }
    ),
    /* @__PURE__ */ j.jsx(
      V.Menu,
      {
        onMouseEnter: S,
        onMouseLeave: E,
        children: g.map((_) => /* @__PURE__ */ j.jsx(
          V.Item,
          {
            onClick: (d) => {
              d.preventDefault(), f(_.tpl);
            },
            children: _.label
          },
          _.label
        ))
      }
    )
  ] }) });
}, _r = { plugin: { chart_editor: {
  backend: { info: {
    name: { other: "Chart Editor" },
    description: { other: "Render chart in editor" }
  } },
  frontend: {
    title: "Chart",
    text: "Chart",
    flow_chart: "Flow chart",
    sequence_diagram: "Sequence diagram",
    class_diagram: "Class diagram",
    state_diagram: "State diagram",
    entity_relationship_diagram: "Entity relationship diagram",
    user_defined_diagram: "User defined diagram",
    gantt_chart: "Gantt chart",
    pie_chart: "Pie chart"
  }
} } }, br = { plugin: { chart_editor: {
  backend: { info: {
    name: { other: "图表编辑器" },
    description: { other: "在编辑器中渲染图表" }
  } },
  frontend: {
    title: "图表",
    text: "图表",
    flow_chart: "流程图",
    sequence_diagram: "时序图",
    class_diagram: "类图",
    state_diagram: "状态图",
    entity_relationship_diagram: "ER 图",
    user_defined_diagram: "用户自定义图",
    gantt_chart: "甘特图",
    pie_chart: "饼图"
  }
} } }, Er = {
  en_US: _r,
  zh_CN: br
}, we = {
  slug_name: "chart_editor",
  type: "editor",
  version: "1.2.9",
  author: "answerdev",
  link: "https://github.com/apache/incubator-answer-plugins/tree/main/editor-chart"
}, Or = {
  info: {
    type: we.type,
    slug_name: we.slug_name
  },
  component: gr,
  i18nConfig: Er,
  hooks: {
    useRender: [De]
  }
};
export {
  Or as default
};
